module.exports = __webpack_public_path__ + "static/media/nurul_angelia.af0fbc71.jpg";